import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { UmsService } from '../ums.service';
import { ModalpopService } from '../modalpop.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe } from '@angular/common';
import { Overlay } from '@angular/cdk/overlay';
import { ActivatedRoute } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { Subscriber } from 'rxjs/internal/Subscriber';
import { Observable } from 'rxjs/internal/Observable';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { PdfviewerComponent } from '../pdfviewer/pdfviewer.component';
import { log } from 'console';

@Component({
  selector: 'app-tc-document-upload',
  templateUrl: './tc-document-upload.component.html',
  styleUrls: ['./tc-document-upload.component.scss']
})
export class TcDocumentUploadComponent implements OnInit {
  TclcDocData: any;
  tcDocumentUploadForm: FormGroup
  SessionNo: any;
  arr: any;
  TclcDocId: any;

  constructor(private dialog: MatDialog,
    private fb: FormBuilder,
    public umsService: UmsService,
    private spinner: NgxSpinnerService,
    @Inject(MAT_DIALOG_DATA) public data: any, private modalPopupService: ModalpopService) { }

  @ViewChild('fileUploader') fileUploader: ElementRef;
  fileName: string;
  errormessage: string;
  dialogRef: MatDialogRef<any>;
  uploadDoc: any;
  fileUploads: any;
  errMsg: any;
  DocView = false;
  SaveBtn = false;
  UpdateBtn = false;

  ngOnInit(): void {
    this.tcDocumentUploadForm = this.fb.group({
      newDocumentArray: this.fb.array([])
    });
    if (JSON.parse(sessionStorage.getItem("session")) == null) {
      this.fetchSecretData();
    }
    else if (JSON.parse(sessionStorage.getItem("session")) != null) {
      let sessionData = JSON.parse(sessionStorage.getItem("session"));
      this.SessionNo = sessionData.SnNo
      this.getTclcDocs(this.data['StuId'], this.SessionNo)
    }
    this.addNewRow()

    if (!this.data.Emid) {
    const session = JSON.parse(sessionStorage.getItem('session'));
    this.data.Emid = session?.Emid;
  }

  console.log('Final Dialog Data:', this.data);
  }

  fetchSecretData() {
    this.spinner.show()
    this.umsService.getSecretData().subscribe((res) => {
      this.spinner.hide();
      this.SessionNo = res.projectPharam['SnNo']
      this.getTclcDocs(this.data['StuId'], this.SessionNo)
    }
    );
  }

  getTclcDocs(StuId, SessionNo) {
    this.spinner.show()
    let payload = {};
    payload['SessionId'] = SessionNo,
    payload['StuId'] = StuId,
    payload['Emid'] = this.data['Emid'],
    payload['StuSubId'] = this.data['StuSubId']

    const creds = this.tcDocumentUploadForm.controls.newDocumentArray as FormArray;
    creds.clear();
    this.umsService.GetTcLcDocUploadDetails(payload).subscribe(
      (res) => {
        if (res.status) {
          this.SaveBtn = false;
          this.UpdateBtn = true;

          this.TclcDocData = res.data.filter(record => record.StuId == StuId);
          if (this.TclcDocData && this.TclcDocData.length > 0) {
            this.DocView = true;

            creds.clear(); 
            this.TclcDocData.forEach((obj, i) => {
              const tempObj = {
                DocumentName2: new FormControl(obj.DocName),
                SrNo2: new FormControl(obj.SrNo),
                docFile2: new FormControl(''),
                DocumentFile2: new FormControl(obj.FileUpload),
                TclcDocId2: new FormControl(obj.TclcDocId)
              };
              this.TclcDocId = obj.TclcDocId;
              if (!this.fileUploads) {
                this.fileUploads = [];
              }

              if (!this.fileUploads[i]) {
                this.fileUploads[i] = {};
              }
              this.fileUploads[i] = obj.FileUpload;

              creds.push(new FormGroup(tempObj));
            });

            this.spinner.hide();
          } else {
            this.DocView = false;
            this.SaveBtn = true;
            this.UpdateBtn = false;
            this.addNewRow()
          }
        }
        else {
          this.spinner.hide();
          this.DocView = false;
          this.SaveBtn = true;
          this.UpdateBtn = false;
          this.addNewRow()
        }
      }, (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
      })
  }

  onChange($event: Event, rowIndex: number) {
    const fileInput = $event.target as HTMLInputElement;
    const formArray = this.tcDocumentUploadForm.get('newDocumentArray') as FormArray;
    const formGroup = formArray.at(rowIndex) as FormGroup;

    const documentName = formGroup.get('DocumentName')?.value;

    const file = fileInput.files[0];
    if (!file) {
      return; 
    }

    this.fileName = file.name;
    const faControl = (<FormArray>this.tcDocumentUploadForm.controls['newDocumentArray']).at(rowIndex);

    // File size validation
    if (file.size >= 3000000) {
      this.errormessage = 'Please upload a file smaller than 3 MB';
      const data = {
        message: this.errormessage,
        title: 'Information',
        icon: 'fas fa-close'
      };
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.dialogRef.afterClosed().subscribe(() => {
        this.fileName = '';
        fileInput.value = '';
        faControl['controls'].docFile.setValue('');
        faControl['controls'].DocumentFile.setValue('');
      });
    } else {
      this.errormessage = '';
      const ext = this.fileName.substring(this.fileName.lastIndexOf('.') + 1).toLowerCase();

      if (ext === 'pdf') {
        this.convertToBase64(file, rowIndex);
        faControl['controls'].DocumentFile.setValue(this.fileName);
        faControl['controls'].DocumentFile.markAsTouched();
      } else {
        faControl['controls'].docFile.setValue('');
        faControl['controls'].DocumentFile.setValue('');
        faControl['controls'].DocumentFile.markAsTouched();
        const data = {
          message: documentName === 'Please upload only PDF files',
          title: 'Information',
          icon: 'fas fa-close'
        };
        // this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        // this.dialogRef.afterClosed().subscribe(() => {
        //   this.fileName = '';
        //   fileInput.value = '';
        // });
      }
    }
  }

  convertToBase64(file: File, rowIndex: number) {
    const observable = new Observable((subscriber: Subscriber<any>) => {
      this.readFile(file, subscriber);
    });

    observable.subscribe((d) => {
      this.uploadDoc = d;
      if (!this.fileUploads) {
        this.fileUploads = [];  // Initialize if it's undefined
      }

      if (!this.fileUploads[rowIndex]) {
        this.fileUploads[rowIndex] = {}; 
      }
      this.fileUploads[rowIndex] = d;
      let base64Str = d.split(',');
      let filee = base64Str[1];
      const faControl = (<FormArray>this.tcDocumentUploadForm.controls['newDocumentArray']).at(rowIndex);
      faControl['controls'].docFile.setValue(filee);
      faControl['controls'].DocumentFile.setValue(file.name);

    });
  }

  readFile(file: File, subscriber: Subscriber<any>) {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = () => {
      subscriber.next(fileReader.result);
      subscriber.complete();
    };
    fileReader.onerror = (error) => {
      subscriber.error(error);
      subscriber.complete();
    };
  }
  
getDocName(element: any): string {
  if (this.data?.CertType === 'ASC') {
    const stuId = this.data.StuId;
    const subjectId = this.data.StuSubId;

    return `ANSWERSHEET-${stuId}-${subjectId}`;
  }
  if (this.data?.CertType === 'LANG') {
    const stuId = this.data.StuId;
    return `LANG-${stuId}`;
  }
  if (this.data?.CertType === 'ATTFE') {
    const stuId = this.data.StuId;
    return `ATTESTATION-${stuId}`;
  }
   if (this.data?.CertType === 'VOD') {
    const stuId = this.data.StuId;
    return `VERIFIED_DOCUMENT-${stuId}`;
  }
  return element?.DocumentName2 || '';
}




 saveTCDocument() {
  this.spinner.show()
  const submitpayload = this.tcDocumentUploadForm.value
  let iserror = false;
  let newDoc = this.tcDocumentUploadForm.controls.newDocumentArray.value;

  var bar = new Promise<void>((resolve, reject) => {
    this.tcDocumentUploadForm.controls.newDocumentArray.value.forEach((element, index, array) => {
      let payload = {};
      payload['StuId'] = this.data['StuId'],
      payload['Emid'] = this.data['Emid'],
      payload['StuSubId'] = this.data['StuSubId'],
      payload['CertType'] = this.data['CertType'] || 'TS',
      payload['TclcId'] = this.data['TclcId'], // Added TclcId here
      payload['DocName'] = this.getDocName(element),
      payload['FileUpload'] = this.fileUploads[index];
      
      setTimeout(() => {
        this.umsService.saveDocUploadDetails(payload).subscribe(res => {
          if (res.status == false) {
            iserror = true;
            this.errMsg = res.message;
          } else {
            iserror = false;
            this.errMsg = res.message;
          }
          if (index === array.length - 1) resolve();
          this.fileUploader.nativeElement.value = null;
        }, (ERROR: HttpErrorResponse) => {
          this.spinner.hide()
          iserror = true;
          this.errMsg = ERROR.error.message;
          if (index === array.length - 1) resolve();
        });
      }, index * 2000);
    });
  })
  bar.then(() => {
    if (iserror == false) {
      this.spinner.hide();
      let data = {}
      data['message'] = "Submitted Successfully"
      data['title'] = 'Information'
      data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.dialogRef.afterClosed().subscribe(result => {
        this.getTclcDocs(this.data['StuId'], this.SessionNo)
      });

    } else {
      this.spinner.hide();
      let data = {}
      data['message'] = this.errMsg
      data['title'] = 'Alert'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.dialogRef.afterClosed().subscribe(result => {

      });
    }
  });
}

  showbase64(e) {
    const dialogRef3 = this.dialog.open(PdfviewerComponent,
      {
        width: "400px",
        height: "500px",
        data: e.value.DocumentFile
      });
  }

  getnewDocumentArrayControls() {
    return (this.tcDocumentUploadForm.get('newDocumentArray') as FormArray).controls;
  }

  // addNewRow() {
  //   const creds2 = this.tcDocumentUploadForm.controls.newDocumentArray as FormArray;
  //   creds2.push(
  //     this.fb.group({
  //       srNo2: new FormControl(''),
  //       DocumentName2: new FormControl(''),
  //       docFile2: new FormControl(''),
  //       DocumentFile2: new FormControl(''),

  //     })
  //   );
  // }
// addNewRow() {
//   const isASC = this.data?.CertType === 'ASC';
//   const creds2 = this.tcDocumentUploadForm.controls.newDocumentArray as FormArray;

//   const docName = isASC
//     ? `ANSWERSHEET-${this.data.StuId}-${this.data.StuSubId}`
//     : '';

//   const docNameCtrl = new FormControl(docName);

//   if (isASC) {
//     docNameCtrl.disable();
//   }

//   creds2.push(
//     this.fb.group({
//       srNo2: new FormControl(''),
//       DocumentName2: docNameCtrl,
//       docFile2: new FormControl(''),
//       DocumentFile2: new FormControl('')
//     })
//   );
// }
addNewRow() {
  const certType = this.data?.CertType;
  const isAutoNamed = certType === 'ASC' || certType === 'LANG' || certType === 'ATTFE' || certType === 'VOD';
  const creds2 = this.tcDocumentUploadForm.controls.newDocumentArray as FormArray;

  let docName = '';
  if (isAutoNamed) {
    if (certType === 'ASC') {
      docName = `ANSWERSHEET-${this.data.StuId}-${this.data.StuSubId}`;
    } else if (certType === 'LANG') {
      docName = `LANGUAGE-${this.data.StuId}`;
    } else if (certType === 'ATTFE') {
      docName = `ATTESTATION-${this.data.StuId}`;
    } else if (certType === 'VOD') {
      docName = `VERIFIED_DOCUMENT-${this.data.StuId}`;
    }
  }

  const docNameCtrl = new FormControl(docName);
  if (isAutoNamed) {
    docNameCtrl.disable();
  }

  creds2.push(
    this.fb.group({
      srNo2: new FormControl(''),
      DocumentName2: docNameCtrl,
      docFile2: new FormControl(''),
      DocumentFile2: new FormControl('')
    })
  );
}


  save() {
    if (this.tcDocumentUploadForm.invalid) {
      const creds = this.tcDocumentUploadForm.get('newDocumentArray') as FormArray;

      creds.controls.forEach(element => {
        if ((element.value.DocumentFile2 === '' || element.value.DocumentFile2 === null) && (element.value.DocumentName2 != '' || element.value.DocumentName2 != null)) {
          element.get('DocumentFile2').setValidators([Validators.required]);
          element.get('DocumentFile2').updateValueAndValidity();
          element.get('DocumentFile2').markAsTouched();
        }
        else if ((element.value.DocumentName2 === '' || element.value.DocumentName2 === null) && (element.value.DocumentFile2 != '' || element.value.DocumentFile2 != null)) {
          element.get('DocumentName2').setValidators([Validators.required]);
          element.get('DocumentName2').updateValueAndValidity();
          element.get('DocumentName2').markAsTouched();
        }
        else if ((element.value.DocumentName2 === '' || element.value.DocumentName2 === null) && (element.value.DocumentFile2 === '' || element.value.DocumentFile2 === null)) {
          element.get('DocumentFile2').setValidators([Validators.required]);
          element.get('DocumentFile2').updateValueAndValidity();
          element.get('DocumentFile2').markAsTouched();
          element.get('DocumentName2').setValidators([Validators.required]);
          element.get('DocumentName2').updateValueAndValidity();
          element.get('DocumentName2').markAsTouched();
        }
        else {
          element.get('DocumentFile2').clearValidators()
          element.get('DocumentFile2').updateValueAndValidity();
          element.get('DocumentName2').clearValidators()
          element.get('DocumentName2').updateValueAndValidity();
        }

      })
    } else {

      this.saveTCDocument()
    }


  }
    viewPdf(index: number) {
      const base64Pdf = this.fileUploads[index];

      if (!base64Pdf) {
        return;
      }

      const base64 = base64Pdf.includes(',')
        ? base64Pdf.split(',')[1]
        : base64Pdf;

      const byteCharacters = atob(base64);
      const byteNumbers = new Array(byteCharacters.length);

      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      const blob = new Blob([new Uint8Array(byteNumbers)], {
        type: 'application/pdf'
      });

      const fileURL = URL.createObjectURL(blob);
      window.open(fileURL, '_blank');
    }


  update() {
  this.spinner.show()
  const submitpayload = this.tcDocumentUploadForm.value
  let iserror = false;
  let newDoc = this.tcDocumentUploadForm.controls.newDocumentArray.value;
  
  var bar = new Promise<void>((resolve, reject) => {
    this.tcDocumentUploadForm.controls.newDocumentArray.value.forEach((element, index, array) => {
      let payload = {};
      payload['TclcDocId'] = this.TclcDocId
      payload['StuId'] = this.data['StuId'],
      payload['Emid'] = this.data['Emid'],
      payload['StuSubId'] = this.data['StuSubId'],
      payload['CertType'] = this.data['CertType'] || 'TS',
      payload['TclcId'] = this.data['TclcId'], // Added TclcId here
      payload['DocName'] = this.getDocName(element),
      payload['FileUpload'] = this.fileUploads[index] == undefined ? element.DocumentFile : this.fileUploads[index];
      
      setTimeout(() => {
        this.umsService.updateDocUploadDetails(payload).subscribe(res => {
          if (res.status == false) {
            iserror = true;
            this.errMsg = res.message;
          } else {
            iserror = false;
            this.errMsg = res.message;
          }
          if (index === array.length - 1) resolve();
          this.fileUploader.nativeElement.value = null;
        }, (ERROR: HttpErrorResponse) => {
          this.spinner.hide()
          iserror = true;
          this.errMsg = ERROR.error.message;
          if (index === array.length - 1) resolve();
        });
      }, index * 2000);
    });
  })
  bar.then(() => {
    if (iserror == false) {
      this.spinner.hide();
      let data = {}
      data['message'] = "Updated Successfully"
      data['title'] = 'Information'
      data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.dialogRef.afterClosed().subscribe(result => {
        this.getTclcDocs(this.data['StuId'], this.SessionNo)
      });

    } else {
      this.spinner.hide();
      let data = {}
      data['message'] = this.errMsg
      data['title'] = 'Alert'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.dialogRef.afterClosed().subscribe(result => {

      });
    }
  });
}
}